import React from 'react';
import { Checkbox } from 'antd';
import FormItem from '../FormItem/FormItem';

const CheckboxField = ({
  form,
  label,
  name,
  decoratorOptions,
  fieldProps = {},
  formItemProps = {},
}) => {
  const { getFieldDecorator } = form;

  return (
    <FormItem
      label={label}
      {...formItemProps}
    >
      {getFieldDecorator(name, {
        ...decoratorOptions,
        valuePropName: 'checked',
      })(<Checkbox {...fieldProps} />)}
    </FormItem>
  );
};

export default CheckboxField;
